import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  Typography,
  withStyles,
} from '@material-ui/core';
import FacebookIcon from 'src/icons/Facebook';
import MicrosoftIcon from 'src/icons/Microsoft';
import GoogleIcon from 'src/icons/Google';
import Page from 'src/components/Page';
import * as uuid from 'uuid';
import CookieConsent from '../../components/CookieConsent';

const styles = (theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: '100%',
    paddingBottom: theme.spacing(3),
  }
});

class LoginView extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.checkFBLogin = this.checkFBLogin.bind(this);
    this.loginMs = this.loginMs.bind(this);
    this.loginGoogle = this.loginGoogle.bind(this);
  }

  handleSubmit(e) {
    console.log(e);
  }

  async loginGoogle() {
    const state = uuid.v4();
    const nonce = uuid.v4();
    localStorage.setItem('stateGoogle', state);
    window.location = 'https://accounts.google.com/o/oauth2/v2/auth'
      + `?client_id=${window['googleClientId']}`
      + '&response_type=token%20id_token'
      + `&redirect_uri=${window['redirectUrl']}app/login-google`
      + '&scope=openid%20profile%20email'
      + `&state=${state}`
      + `&nonce=${nonce}`;
  }

  async checkFBLogin() {
    const state = uuid.v4();
    localStorage.setItem('state', state);
    window.location = 'https://www.facebook.com/v12.0/dialog/oauth?'
    + `client_id=${window['fbClientId']}&redirect_uri=${window['redirectUrl']}app/login-facebook&`
    + `state=${state}&response_type=token,granted_scopes&scope=public_profile,email&auth_type=rerequest`;
  }

  async loginMs() {
    const stateMs = uuid.v4();
    localStorage.setItem('stateMs', stateMs);
    window.location = 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize?'
      + '&response_type=token&scope=openid,profile,email'
      + `&state=${stateMs}`
      + `&client_id=${window['msClientId']}`
      + `&redirect_uri=${window['redirectUrl']}app/login-microsoft`;
  }

  render() {
    const { classes } = this.props;

    return (
      <Page
        className={classes.root}
        title="Login"
      >
        <CookieConsent />
        <Box
          display="flex"
          flexDirection="column"
          height="100%"
          justifyContent="center"
        >
          <Container maxWidth="sm">
            <Formik
              initialValues={{
                email: 'demo@devias.io',
                password: 'Password123'
              }}
              validationSchema={Yup.object().shape({
                email: Yup.string().email('Must be a valid email').max(255).required('Email is required'),
                password: Yup.string().max(255).required('Password is required')
              })}
            >
              {/* eslint-disable-next-line no-empty-pattern */}
              {({ }) => (
                <form onSubmit={this.handleSubmit}>
                  <Box mb={3}>
                    <Typography
                      color="textPrimary"
                      variant="h2"
                    >
                      Sign in
                    </Typography>
                    <Typography
                      color="textSecondary"
                      gutterBottom
                      variant="body2"
                    >
                      Sign in on the internal platform
                    </Typography>
                  </Box>
                  <Grid
                    container
                    spacing={3}
                  >
                    <Grid
                      item
                      xs={12}
                      md={6}
                    >
                      <Button
                        color="primary"
                        fullWidth
                        startIcon={<FacebookIcon/>}
                        onClick={this.checkFBLogin}
                        size="large"
                        variant="contained"
                      >
                        Login with Facebook
                      </Button>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={6}
                    >
                      <Button
                        fullWidth
                        startIcon={<MicrosoftIcon/>}
                        onClick={this.loginMs}
                        size="large"
                        variant="contained"
                      >
                        Login with Microsoft
                      </Button>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={6}
                    >
                      <Button
                        fullWidth
                        startIcon={<GoogleIcon/>}
                        onClick={this.loginGoogle}
                        size="large"
                        variant="contained"
                      >
                        Login with Google
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              )}
            </Formik>
            <Box mt={3} display="flex" justifyContent="center">
              <Typography variant="body2" color="textSecondary">
                <Link component={RouterLink} to="/privacy-policy" color="inherit">
                  Privacy Policy
                </Link>
                {' · '}
                <Link component={RouterLink} to="/terms" color="inherit">
                  Terms of Service
                </Link>
              </Typography>
            </Box>
          </Container>
        </Box>
      </Page>
    );
  }
}

LoginView.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(LoginView);
